<template>
    <div class="filling-goods-div">
        <div style="padding-top: 5px; font-size: 16px">半成品入库</div>
        <div style="display: flex; justify-content: space-between; align-items: center; padding: 10px 0;"
            v-if="outNumber === '未出库'">
            <van-button type="info" size="small" style="display: flex" :text="ray" @click="holdRay()"></van-button>
            <!-- <div>
                <input id="reel-input" class="input-goods" @keyup.enter="goGoods()" ref="getIDInpot" v-model="reeldata"
                    v-on:blur="hideMessage('reeldata')" readonly autocomplete="off" placeholder="请扫描货位" />
            </div> -->
            <div>
                <input id="reel-input" class="input-goods"  @keyup.enter="goGck()" ref="getGCKInpot" v-model="gckdata"
                    v-on:blur="hideMessage('gckdata')" readonly autocomplete="off" placeholder="请扫描卷号" />
            </div>
        </div>
        <div class="filling-goods-head">
            <div class="filling-goods-head-div">
                <div class="search-goods">
                    <div style="text-align: left; font-size: 22px;">货位：{{ goods }}</div>
                </div>
                <div class="goods-link-header">
                    <div style="width: 40%; text-align: left; font-size: 22px;">入库类型:</div>
                    <!-- <div style="width: 60%; font-size: 22px;"></div> -->
                    <input style="width: 50%;height: 25px; text-align: center;line-height: 25px;font-size: 16px;"
                        @click="TypePicker(0)" v-model="returnType" readonly="readonly" />
                    <van-popup v-model="showPicker" position="bottom">
                        <van-picker :columns="returnList" @change="onChange"></van-picker>
                    </van-popup>
                </div>
                <div class="goods-link-header">
                    <div style="width: 40%; text-align: left;  font-size: 22px;">货号:</div>
                    <input style="width: 50%;height: 25px; line-height: 25px;font-size: 16px; text-align: center;"
                        v-model="goods_number" @keyup.enter="goSearchFabric()" />
                </div>
                <div class="goods-link-header">
                    <div style="width: 40%; text-align: left;  font-size: 22px;">款式:</div>
                    <input style="width: 50%;height: 25px; text-align: center;line-height: 25px;font-size: 16px;"
                        @click="TypePicker(1)" v-model="KsType" readonly="readonly" />
                    <van-popup v-model="KsPicker" position="bottom">
                        <van-picker :columns="KsList" @change="KsChange"></van-picker>
                    </van-popup>
                </div>
                <div class="goods-link-header">
                    <div style="width: 40%; text-align: left;  font-size: 22px;">宽度(m):</div>
                    <input style="width: 50%;height: 25px; line-height: 25px;font-size: 16px; text-align: center;"
                        v-model="width_num" />
                </div>
                <div class="goods-link-header">
                    <div style="width: 40%; text-align: left;  font-size: 22px;">高度(m):</div>
                    <input style="width: 50%;height: 25px; line-height: 25px;font-size: 16px; text-align: center;"
                        v-model="height_num" />
                </div>
                <div class="goods-link-header">
                    <div style="width: 40%; text-align: left;  font-size: 22px;">数量:</div>
                    <input style="width: 50%;height: 25px; line-height: 25px;font-size: 16px; text-align: center;"
                        v-model="count" type="number" />
                </div>
                <div class="goods-link-header">
                    <div style="width: 20%; text-align: left;  font-size: 22px;">备注:</div>
                    <input style="width: 90%;height: 40px;" v-model="reelInfo" />
                </div>
            </div>
        </div>

        <span style="color: red" v-if="hostcs">测试服</span>
        <button v-if="hostcs" @click="goSearchFabric()">测试回车</button>
        <div class="filling-goods-bottom" style="display: flex">
            <van-button type="warning" class="bottom-button" @click="go_index()">回首页</van-button>
            <van-button type="info" class="bottom-button" @click="go_print()">入库打印</van-button>
        </div>
        <van-popup v-model="show" style="height: 70%;width: 80%; overflow: auto;">
            <div class="data-top-header">
                <div class="right-twenty-header">货号</div>
                <!-- <div class="right-twenty-header">规格</div> -->
                <!-- <div class="right-twenty-header">供应商</div> -->
            </div>
            <div class="data-top" v-for="(i, index) in data" :key="index" @click="select(index)">
                <div class="data-order">{{ i.number }}</div>
                <!-- <div class="data-order">{{ i.normVals }}</div> -->
                <!-- <div class="data-order">{{ i.supplier_name }}</div> -->
            </div>
        </van-popup>
        <van-popup v-model="show_print" style="width: 200px;" @close="handlePopupClose">
            <div style="padding:10px;" class="print-only" id="popupPrint">
                <div>
                    <div class="list-data">
                        <div class="list-data-div">货号:</div>
                        <div class="list-data-div">{{ goods_number }}</div>
                    </div>
                    <div class="list-data">
                        <div class="list-data-div">数量:</div>
                        <div class="list-data-div">{{ count }}</div>
                    </div>
                    <div class="list-data">
                        <div class="list-data-div-a">货位:</div>
                        <div class="list-data-div-a">{{ goods }}</div>
                    </div>
                    <div class="list-data">
                        <div class="list-data-div-a">款式:</div>
                        <div class="list-data-div-a">{{ KsType }}</div>
                    </div>
                    <div class="list-data">
                        <div class="list-data-div-a">高度(m):</div>
                        <div class="list-data-div-a">{{ height_num }}</div>
                    </div>
                    <div class="list-data">
                        <div class="list-data-div-a">宽度(m):</div>
                        <div class="list-data-div-a">{{ width_num }}</div>
                    </div>
                    <div class="list-data">
                        <div class="list-data-div-a">备注:</div>
                        <div class="list-data-div-a">{{ reelInfo }}</div>
                    </div>
                    <div class="list-data">
                        <div class="list-data-div-a">时间:</div>
                        <div class="list-data-div-a">{{ nowtime }}</div>
                    </div>
                </div>
                <Barcode :JsBarcodeData="JsBarcodeConfigData" />
            </div>
            <van-button type="info" @click="dayin()" style="width: 100px; margin : 10px;">打印</van-button>
        </van-popup>
    </div>
</template>

<script>
import $ from "jquery";
import { mapState, mapMutations } from "vuex";
import { Dialog } from "vant";
import { Toast } from "vant";
import axios from 'axios';
import Barcode from '@/components/Barcode';
import html2canvas from 'html2canvas';
export default {
    name: "orderInfo",
    name: "barcode",
    components: {
        Barcode
    },
    data() {
        return {
            hostcs: false,
            more_show: false,
            ray: "扫描中",
            id: "",
            supplier_xh: "",
            supplier_name: "",
            name: "",
            count: "",
            cylinder_number: "",
            count_up: "",
            data: [],
            returnList: [
                //'成品入库',
                '半成品入库',
            ],
            returnType: '半成品入库',
            KsType: '韩折',
            KsList: [
                '韩折',
                '挂钩',
                '打孔',
            ],
            KsPicker: false,
            showPicker: false,
            style: "",
            reeldata: "",
            gckdata: '',
            reelInfo: "",
            goods_number: "",
            fillingGoodsType: true,
            revocationType: true,
            outNumber: "未出库",
            username: "",
            type: "orderInfo",
            show: false,
            show_print: false,
            nowtime: '',
            jieliu: false,
            count: '',
            height_num: '',
            width_num: '',
            goods: '',
            JsBarcodeConfigData: {
                text: '', // 条形码必须是字符串类型，否则会出现后面几位为数字的情况。
                lineColor: "#000000", //二维码颜色
                background: "#fff", //二维码背景色
                //width: this.widthStyleObj, 
                bottomtext: '',
            }
        };
    },
    mounted() {
        //this.tableDomId = 'printCodeTable';
        this.username = JSON.parse(window.localStorage.getItem("userinfo"));
        if (this.$route.query.id !== undefined) {
            this.getIdData(this.$route.query.id);
        }
        var h = document.documentElement.clientHeight || document.body.clientHeight;
        this.style =
            "text-align: left;width: 100%;height: " + h * 0.66 + "px;";
        setTimeout(() => {
            this.gck_input();
        }, 500);
        if (window.location.host.indexOf("cspda") !== -1) {
            this.hostcs = true;
        }
    },
    methods: {
        goGoods() {
            this.goods = this.reeldata;
            this.gckdata = '';
            //this.gck_input();
        },
        hideMessage(title) {
            if (title === "reeldata") {
                if (this.reeldata === "") {
                    this.ray = "已暂停，点击我继续扫码";
                }
            }
            if (title === "gckdata") {
                if (this.gckdata === "") {
                    this.ray = "已暂停，点击我继续扫码";
                }
            }
        },
        holdRay() {
            this.ray = "扫描中";
            if (this.reeldata === "") {
                this.gck_input();
            } else if (this.gckdata === "") {
                this.gck_input();
            }
        },
        focus() {
            this.$refs.getIDInpot.focus();
            this.$refs.getIDInpot.setAttribute("readonly", "readonly");
            setTimeout(() => {
                this.$refs.getIDInpot.removeAttribute("readonly");
            }, 200);
        },
        gck_input() {
            this.$refs.getGCKInpot.focus();
            this.$refs.getGCKInpot.setAttribute("readonly", "readonly");
            setTimeout(() => {
                this.$refs.getGCKInpot.removeAttribute("readonly");
            }, 200);
        },
        handlePopupClose() {
            this.reelInfo = '';
            this.count = '';
            this.width_num = '';
            this.height_num = '';
            this.goods_number = '';
        },
        TypePicker(index) {
            if (index == 1) {
                this.KsPicker = true;
            } else {
                this.showPicker = true;
            }
            // this.isDate = index;
        },
        onChange(picker, value, index) {
            this.returnType = value;
            if(value == '半成品入库'){
                this.KsType = '';
            }
            this.showPicker = false;
        },
        KsChange(picker, value, index) {
            this.KsType = value;
            this.KsPicker = false;
        },
        select(index) {
            this.show = false;
            this.goods_number = this.data[index].number;
            this.supplier_xh = this.data[index].supplier_xh;
            this.supplier_name = this.data[index].supplier_name;
        },
        goGck() {
            this.get(this.APIOBJ.reelGetGoodsorder, { reel: this.gckdata }).then(
                (res) => {
                    if (res.data.status == 1) {
                        const regex = /(.*?)\/宽(\d+(\.\d+)?)\/高(\d+(\.\d+)?)/;
                        const matches = res.data.data.size.match(regex);
                        if (matches) {
                            this.ksType = matches[1]; // 韩折
                            this.width_num = matches[2]; // 2
                            this.height_num = matches[4]; // 3
                        }
                        this.goods_number = res.data.data.number;
                        this.goods= res.data.data.goods;
                        //this.count = res.data.data.goods_count;
                    }else{
                        Toast(res.data.msg);
                        this.gckdata = '';
                        this.gck_input();
                    }
                }
            )
        },
        goSearchFabric() {   // 输入货号和型号 查找
            var newApiUrl = window.localStorage.getItem('pdaBASEURL').replace('/api', '');
            if (this.goods_number.length >= 2) {
                this.get(newApiUrl + this.APIOBJ.searchFabricRd, {number: this.goods_number, supplier: '', reel: 1 }).then(
                    (res) => {
                        if (res.data.status == 1) {
                            this.data = res.data.data
                            this.show = true;
                        } else if (res.data.status == 0) {
                            Toast(res.data.msg);
                        } else {
                            Toast('失败');
                        }
                    }
                );
            } else {
                Toast('货号最少三位数!');
            }
        },
        go_print() {
            const str = this.KsType+'/宽'+this.width_num+'/高'+this.height_num
            if (this.count != "" && this.count >= 0 && this.goods_number != "" && this.width_num != "" && this.height_num != "" && this.goods != "") {
                // this.get("/IncreaseStoreRD", {
                //     number: this.goods_number,
                //     reel_detail: this.reelInfo,
                //     size: str,
                //     store: this.count,
                //     godown_type: this.returnType,
                //     goods: this.goods,
                //     gck_number: this.gckdata,
                // }).then((res) => {
                //     if (res.data.status == 1) {
                //         this.nowtime = res.data.data.time
                //         //this.dayin(res.data.data.reel_id)
                //         this.$set(this.JsBarcodeConfigData, 'text', res.data.data.reel_id);
                //         this.$set(this.JsBarcodeConfigData, 'bottomtext', res.data.data.reel_id);
                //         this.show_print = true;
                //     } else if (res.data.status == 0) {
                //         Toast(res.data.msg)
                //     } else {
                //         Toast("失败");
                //     }
                // })
                this.post(this.APIOBJ.ClothAdjustment, { reel: this.gckdata, comment: this.reelInfo, reduce: '-'+this.count }).then(
                    (res) => {
                        if (res.data.status == 1) {
                            this.reelInfo = this.reelInfo_up;
                            this.count = this.count-this.count_up;
                            this.count_up = '';
                            Toast('更新保存成功');
                        } else {
                            Toast('更新失败');
                        }
                    }
                )
            } else {
                Toast('必填项不能为空或负!');
            }
        },
        dayin() {
            html2canvas(document.querySelector("#popupPrint")).then((canvas) => {
                //document.body.appendChild(canvas);
                var imageBase64 = canvas.toDataURL();// 将imageData作为参数传递给callAndroid()方法
                var imageBase64 = imageBase64.replace(/^data:image\/\w+;base64,/, '');
                this.reelInfo = '';
                this.count = '';
                this.supplier_xh = '';
                this.callAndroid(imageBase64);
            });
        },
        callAndroid(imageBase64) {
            var BASE64_ENCODED_IMAGE_DATA = imageBase64;
            var imageData = BASE64_ENCODED_IMAGE_DATA;
            //console.log(imageData);
            this.show_print = false;
            Android.receiveImage(imageData);
            alert("printPreview");
        },
        window_dayin() {
            window.print();
        },
        go_index() {
            Dialog.confirm({
                message: "确定要回首页吗？",
            })
                .then(() => {
                    this.$router.push("/home");
                })
                .catch(() => {
                    // on cancel
                });
        },
        go_scan_url() {
            let url =
                "http://cs.lcyjfz.com/home/scan?id=" + this.$route.query.id || "";
            window.location.href = url;
        },

    },
};

</script>

<style lang="less">
@import "../style/outOrderInfo.less";

.info-data {
    display: flex;
    padding: 0px 10px 10px 10px;
    align-items: center;
    justify-content: center;
}

.input-goods {
    height: 25px;
    width: 3rem;
}

.bottom-button-x {
    border-radius: 0.5em;
    width: 35%;
}

.data-top {
    width: 100%;
    display: flex;
    align-items: center;
    flex-wrap: nowrap;
    justify-content: space-evenly;
}

.data-top-header {
    width: 100%;
    height: 30px;
    display: flex;
    align-items: center;
    flex-wrap: nowrap;
    justify-content: space-evenly;
}

.right-twenty-header {
    width: 100%;
    height: 30px;
    text-align: center;
    align-items: center;
    justify-content: center;
    display: flex;
    border-bottom: 0.1px solid #000;
    border-right: 0.1px solid #000;
}

.data-order {
    width: 100%;
    height: 30px;
    text-align: center;
    align-items: center;
    justify-content: center;
    word-wrap: break-word;
    display: flex;
    border-bottom: 0.1px solid #000;
    border-right: 0.1px solid #000;
}

.data-link {
    color: lightgray;
    display: flex;
    padding: 5px 10px 5px 10px;
}

.data-link-g {
    color: lightgray;
    display: flex;
    padding: 5px 10px 5px 10px;
    width: 50%;
}

.data-link-b {
    display: flex;
    padding: 5px 10px 5px 10px;
    width: 50%;
    align-items: center;
}

.goods-link-header {
    display: flex;
    padding: 5px 10px 5px 10px;
    align-items: center;
}

.list-data {
    display: flex;
    align-items: center;
    margin-top: 10px;
    margin-bottom: 10px;
}

.list-data-div {
    padding-right: 3px;
    text-align: left;
    font-size: 18px;
}

.list-data-div-a {
    padding-right: 3px;
    text-align: left;
    font-size: 14px;
}


.search-goods {
    display: flex;
    padding: 5px 10px 5px 10px;
    align-items: center;
}

@media print {
    .print-only {
        display: block; // 仅在打印时显示
    }

    .no-print {
        display: none; // 不在打印时显示
        //margin: 10px;
    }

    @page {
        size: A4;
        /* 设置纸张大小为 A4 */
        margin: 0;
        /* 取消默认页边距 */
    }
}
</style>